
export default {
  name: "Sheader",
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    },
    showLogo: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      wellcomeLink: ""
    }
  },
  computed: {},
  watch: {},
  created() {
    this.wellcomeLink = this.MAIN_ORIGIN_HOME
  },
  mounted() {},
  methods: {
    handleBack() {
      if (document.referrer.includes("cyberSource/custom/cancelPay")) {
        window.history.go(-3)
      } else if (document.referrer.includes("cyberSource/custom")) {
        window.history.go(-4)
      } else {
        window.history.go(-1)
      }
    }
  }
}
